/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormConfigInterface } from './interfaces/form-config.interface';
import { claimTypes, userTypes, whiteLabelNames } from '../appsettings';
import { FormGroup, Validators } from '@angular/forms';
import { noNumbersAllowedValidator } from './validators/no-numbers-allowed.validator';
import { strictEmailValidator } from './validators/strict-email.validator';
import { passwordValidation } from '../modules/shared/regex-pattern';
import { numericAndLettersOnlyValidator } from './validators/fiscal-code-validators';

export const IT_CONFIG: FormConfigInterface = {
  adminCompleteProfile: [
    { Name: 'given_name', Required: () => true, Type: 'text', Order: 1, Hide: () => false },
    { Name: 'family_name', Required: () => true, Type: 'text', Order: 2, Hide: () => false },
    {
      Name: 'email',
      Required: () => true,
      Type: 'text',
      Order: 3,
      Hide: () => false,
      Readonly: true,
    },
    { Name: 'phone', Required: () => true, Type: 'phone', Order: 4, Hide: () => false },
    { Name: 'locale', Required: () => true, Type: 'locale-picker', Order: 5, Hide: () => false },
    { Name: 'gender', Required: () => true, Type: 'gender-picker', Order: 6, Hide: () => false },
  ],
  personalInfo: [
    {
      Name: 'given_name',
      Required: () => true,
      Type: 'text',
      Order: 1,
      Readonly: true,
      Hide: () => false,
    },
    {
      Name: 'family_name',
      Required: () => true,
      Type: 'text',
      Order: 2,
      Readonly: true,
      Hide: () => false,
    },
    {
      Name: 'fiscal_code',
      Required: () => true,
      Type: 'text',
      Order: 3,
      Readonly: true,
      Hide: () => false,
    },
    {
      Name: 'date_of_birth',
      Required: () => true,
      Type: 'date-picker',
      Order: 4,
      Readonly: true,
      Hide: () => false,
      CustomLabelTranslationKey: 'dobLabel2',
    },
    {
      Name: 'gender',
      Required: () => true,
      Type: 'gender-picker',
      Order: 5,
      Readonly: true,
      Hide: () => false,
      CustomLabelTranslationKey: 'genderLabel2',
    },
    {
      Name: claimTypes.COUNTRY_OF_BIRTH,
      Required: (roles: string[], form: FormGroup) => {
        const isSAUser = roles.includes(userTypes.SYNLAB_ACCESS_USER);
        if (!isSAUser) return false;
        return !form?.get('fiscal_code')?.value;
      },
      Type: 'country-of-birth-selector',
      Order: 0,
      Hide: (roles: string[], form: FormGroup) => {
        const isSAUser = roles.includes(userTypes.SYNLAB_ACCESS_USER);

        if (!isSAUser) return true;

        if (!form) return;

        if (form.get && typeof form.get === 'function') {
          return !!form?.get('fiscal_code')?.value;
        }
        return !!(form as any)?.form?.get('fiscal_code')?.value;
      },
    },
  ],
  contact: [
    {
      Name: 'country_residence',
      Required: () => true,
      Type: 'country-picker',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: 'city',
      // Required: (roles, form, claimsObject?: Record<string, string>) =>
      //   isRequiredWhenItalyCountryResidence(claimsObject),
      Required: () => true,
      Type: claimsObject => {
        const isItaly = claimsObject?.country_residence?.toLowerCase() === whiteLabelNames.ITALY;
        if (isItaly) return 'city-dropdown-selector';
        return 'text';
      },
      Order: 0,
      Hide: () => false,
    },
    {
      Name: 'address',
      // Required: (roles, form, claimsObject?: Record<string, string>) =>
      //   isRequiredWhenItalyCountryResidence(claimsObject),
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
      CustomValidators: [noNumbersAllowedValidator],
    },
    {
      Name: 'address1',
      // Required: (roles, form, claimsObject?: Record<string, string>) =>
      //   isRequiredWhenItalyCountryResidence(claimsObject),
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: 'zipcode',
      // Required: (roles, form, claimsObject?: Record<string, string>) =>
      //   isRequiredWhenItalyCountryResidence(claimsObject),
      Required: () => true,
      Readonly: (roles, form) => {
        const countryResidence = form.get(claimTypes.COUNTRY_RESIDENCE);
        return countryResidence.value?.toLowerCase() === whiteLabelNames.ITALY;
      },
      Type: 'text',
      Order: 0,
      Hide: () => false,
      CustomLabelTranslationKey: 'postalCodeLabel',
    },
    {
      Name: 'phone',
      Required: () => true,
      Type: 'phone',
      Order: 0,
      Hide: () => false,
      CustomLabelTranslationKey: 'phone2',
    },
    {
      Name: 'email',
      Required: () => true,
      Type: 'text',
      Order: 0,
      Readonly: true,
      Hide: () => false,
      CustomLabelTranslationKey: 'email',
    },
  ],
  accountInfo: [
    {
      Name: claimTypes.EMAIL,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Readonly: false,
      Hide: () => false,
      CustomValidators: [strictEmailValidator],
    },
    {
      Name: claimTypes.FISCAL_CODE,
      Required: (roles: string[], form: FormGroup) => {
        const isItalian = !form.get('noFiscalCode').value;
        return Boolean(isItalian);
      },
      Type: 'text',
      Order: 0,
      Readonly: false,
      Hide: () => false,
      CustomValidators: [numericAndLettersOnlyValidator],
    },
    {
      Name: claimTypes.DATE_OF_BIRTH,
      Required: (roles: string[], form: FormGroup) => {
        const isItalian = !form.get('noFiscalCode').value;
        return Boolean(!isItalian);
      },
      Type: 'date-picker',
      Order: 0,
      Readonly: false,
      Hide: (roles: string[], form: FormGroup) => {
        const isItalian = !form?.get('noFiscalCode')?.value;
        return Boolean(isItalian);
      },
    },
    {
      Name: 'noFiscalCode',
      Required: () => false,
      Type: 'checkbox',
      Order: 0,
      Readonly: false,
      Hide: () => false,
    },
    {
      Name: 'password',
      Required: () => true,
      Type: 'password',
      Order: 0,
      Readonly: false,
      Hide: () => false,
      CustomValidators: [Validators.pattern(passwordValidation)],
    },
    {
      Name: 'password-validator',
      Required: () => false,
      Type: 'custom',
      Hide: () => false,
    },
    {
      Name: 'confirmPassword',
      Required: () => true,
      Type: 'password',
      Order: 0,
      Readonly: false,
      Hide: () => false,
    },
  ],
  completeProfile: [
    {
      Name: claimTypes.GIVEN_NAME,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.FAMILY_NAME,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.PHONE,
      Required: () => true,
      Type: 'phone',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.GENDER,
      Required: () => true,
      Type: 'radio-group',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.COUNTRY_OF_BIRTH,
      Required: () => true,
      Readonly: true,
      Type: 'country-picker',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: 'highlighted-panel',
      Required: () => true,
      Type: 'custom',
      Hide: () => false,
    },
  ],
  completeProfileAddress: [
    {
      Name: claimTypes.COUNTRY_RESIDENCE,
      Required: () => true,
      Readonly: true,
      Type: 'country-picker',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.CITY,
      // Required: (roles, form) => isRequiredWhenItalyCountryResidenceByForm(form),
      Required: () => true,
      Readonly: false,
      Type: (claims, form) => {
        if (form.get(claimTypes.COUNTRY_RESIDENCE).value !== 'it') {
          return 'text';
        }
        return 'city-dropdown-selector';
      },
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.ADDRESS,
      // Required: (roles, form) => isRequiredWhenItalyCountryResidenceByForm(form),
      Required: () => true,
      Readonly: false,
      Type: 'text',
      Order: 0,
      Hide: () => false,
      CustomValidators: [noNumbersAllowedValidator],
    },
    {
      Name: claimTypes.ADDRESS1,
      // Required: (roles, form) => isRequiredWhenItalyCountryResidenceByForm(form),
      Required: () => true,
      Readonly: false,
      Type: 'text',
      Order: 0,
      Hide: () => false,
      CustomValidators: [Validators.pattern(/^[0-9]*$/)],
    },
    {
      Name: claimTypes.ZIP_CODE,
      // Required: (roles, form) => isRequiredWhenItalyCountryResidenceByForm(form),
      Required: () => true,
      Readonly: (roles, form) => {
        const countryResidence = form.get(claimTypes.COUNTRY_RESIDENCE);
        return countryResidence.value?.toLowerCase() === whiteLabelNames.ITALY;
      },
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
  ],
};

export default IT_CONFIG;
